import React from 'react';
import { Mail, MessageCircle, HelpCircle, Clock } from 'lucide-react';

export default function ContactSupport() {
  const supportEmail = "smartapinvoicing@gmail.com"; // ⚠️ CHANGE THIS TO YOUR ACTUAL EMAIL

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Contact & Support</h1>
          <p className="text-lg text-gray-600">
            We're here to help! Reach out to us for any questions or concerns.
          </p>
        </div>

        {/* Main Contact Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
          <div className="flex items-center justify-center mb-6">
            <div className="bg-indigo-100 p-4 rounded-full">
              <Mail className="w-8 h-8 text-indigo-600" />
            </div>
          </div>
          
          <h2 className="text-2xl font-semibold text-center text-gray-900 mb-4">
            Get in Touch
          </h2>
          
          <p className="text-center text-gray-600 mb-6">
            For all support inquiries, technical issues, billing questions, or general feedback, 
            please email us at:
          </p>

          <div className="bg-indigo-50 border-2 border-indigo-200 rounded-xl p-6 text-center">
            <a 
              href={`mailto:${supportEmail}`}
              className="text-2xl font-semibold text-indigo-600 hover:text-indigo-800 transition-colors"
            >
              {supportEmail}
            </a>
          </div>

          <div className="mt-6 text-center">
            <a
              href={`mailto:${supportEmail}`}
              className="inline-block bg-indigo-600 hover:bg-indigo-700 text-white font-semibold px-8 py-3 rounded-lg transition-colors"
            >
              Send Email
            </a>
          </div>
        </div>

        {/* Support Information Grid */}
        <div className="grid md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white rounded-xl shadow-lg p-6 text-center">
            <div className="bg-green-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4">
              <Clock className="w-6 h-6 text-green-600" />
            </div>
            <h3 className="font-semibold text-gray-900 mb-2">Response Time</h3>
            <p className="text-gray-600 text-sm">
              We typically respond within 24-48 hours on business days
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 text-center">
            <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4">
              <MessageCircle className="w-6 h-6 text-blue-600" />
            </div>
            <h3 className="font-semibold text-gray-900 mb-2">Support Topics</h3>
            <p className="text-gray-600 text-sm">
              Technical issues, billing, account management, feature requests
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 text-center">
            <div className="bg-purple-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4">
              <HelpCircle className="w-6 h-6 text-purple-600" />
            </div>
            <h3 className="font-semibold text-gray-900 mb-2">Need Help?</h3>
            <p className="text-gray-600 text-sm">
              Include detailed information about your issue for faster resolution
            </p>
          </div>
        </div>

        {/* Tips for Better Support */}
        <div className="bg-white rounded-xl shadow-lg p-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">
            📧 Tips for Faster Support
          </h2>
          <ul className="space-y-3 text-gray-600">
            <li className="flex items-start">
              <span className="text-indigo-600 font-bold mr-2">•</span>
              <span><strong>Include your account email</strong> so we can quickly locate your account</span>
            </li>
            <li className="flex items-start">
              <span className="text-indigo-600 font-bold mr-2">•</span>
              <span><strong>Describe the issue in detail</strong> including any error messages</span>
            </li>
            <li className="flex items-start">
              <span className="text-indigo-600 font-bold mr-2">•</span>
              <span><strong>Include screenshots</strong> if applicable</span>
            </li>
            <li className="flex items-start">
              <span className="text-indigo-600 font-bold mr-2">•</span>
              <span><strong>Mention what you've already tried</strong> to resolve the issue</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}